import React, { useEffect, useState } from 'react';
import axiosInstance from '../util/axiosConfig';
import useVendorField from '../hooks/useVendorField';
import StockFormModal from './StockFormModal';
import AddVendorModal from './AddVendorModal';
import MaterialForm, {
  emptyMaterialForm,
  materialFormToPayload,
  validateMaterialForm
} from './MaterialForm';

const AddMaterialModal = ({ open, onClose, onSuccess }) => {
  const [form, setForm] = useState(emptyMaterialForm);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const {
    vendors,
    vendorsLoading,
    addVendorOpen,
    setAddVendorOpen,
    onAddVendor,
    handleVendorCreated
  } = useVendorField(open, (vendorId) => {
    setForm((prev) => ({ ...prev, vendor_id: vendorId }));
  });

  useEffect(() => {
    if (!open) return;
    setForm(emptyMaterialForm());
    setError('');
  }, [open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const message = validateMaterialForm(form);
    if (message) {
      setError(message);
      return;
    }
    try {
      setSubmitting(true);
      await axiosInstance.post('/materials', materialFormToPayload(form));
      onSuccess?.();
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to add material');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <StockFormModal
        open={open}
        onClose={onClose}
        title="Add Material"
        error={error}
        onErrorClose={() => setError('')}
      >
        <MaterialForm
          form={form}
          onChange={handleChange}
          onSubmit={handleSubmit}
          loading={submitting}
          vendors={vendors}
          vendorsLoading={vendorsLoading}
          onAddVendor={onAddVendor}
          fullWidthSubmit={false}
        />
      </StockFormModal>
      <AddVendorModal
        open={addVendorOpen}
        onClose={() => setAddVendorOpen(false)}
        onCreated={handleVendorCreated}
      />
    </>
  );
};

export default AddMaterialModal;
